import { makeStyles } from '@soil-capital/ui-kit/style';

export const useOperationDuplicationRightPanelStyle = makeStyles()((theme) => ({
    listItem: {
        width: '100%',
        padding: 0,
        '& .MuiFormControlLabel-label': {
            width: '100%',
        },
    },
    hide: {
        display: 'none',
    },
    selectAll: {
        display: 'flex',
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    panel: {
        flex: 1,
    },
    fieldInfoBoxOverride: {
        padding: 0,
    },
    switch: {
        marginLeft: 'auto',
        width: '100%',
    },
}));
